import { useId } from 'react';
import Typography from '@alltrails/core/components/Typography';
import type { RangeSliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import { RangeSlider } from '@alltrails/denali/components/Slider';
import useRangeSliderDraft from '../../hooks/useRangeSliderDraft';
import styles from './buildRangeSliderDropdownConfig.module.scss';

/**
 * Body of a filter-bar range-slider dropdown: the current value top-right in bold above a header-less
 * RangeSlider. Drives the slider through `useRangeSliderDraft` so dragging updates local state (and the
 * value display) without dispatching a search per tick; commit on release.
 *
 * https://www.figma.com/design/xr7AP5Bd1HcO5syL0nNhwZ/Explore-Usability-H2-2026?node-id=215-22416&m=dev
 */
const RangeSliderDropdownContent = ({ rangeSlider }: { rangeSlider: RangeSliderFilterConfig['rangeSlider'] }) => {
  const { draft, onChange, onChangeEnd } = useRangeSliderDraft(rangeSlider);
  // The slider renders header-less (its value lives in our own header), so give it an accessible name.
  const labelId = useId();

  return (
    <div className={styles.rangeSliderDropdown}>
      <div className={styles.header}>
        <span className={styles.visuallyHidden} id={labelId}>
          {rangeSlider.label}
        </span>
        <Typography variant="text100bold">{rangeSlider.formatHeaderValue?.(draft)}</Typography>
      </div>
      <RangeSlider marks={rangeSlider.marks} value={draft} onChange={onChange} onChangeEnd={onChangeEnd} ariaLabelledby={labelId} />
    </div>
  );
};

export default RangeSliderDropdownContent;
